type Config = {
  isDev: boolean;
  serverBaseUrl: string;
  host: string;
  chatScriptName: string;
  stripePK: string;
  underMaintenance: boolean;
  shopifyPricingPlanUrl: string;
  whatsAppEmbeddedSignupConfigId: string;
  facebookEmbeddedSignupConfigId: string;
  livekitProjectUrl: string;
};

const prod: Config = {
  isDev: false,
  serverBaseUrl: 'https://api.droxy.ai',
  host: 'app.droxy.ai',
  chatScriptName: 'chat.min.js',
  stripePK:
    'pk_live_51MmP7xJ94jlMIjO8tS2gZNqf3fnHcPeHTIEf2MLabHl6TTAr42pYeYV9Rs9p9AMjJFyH5zyMrvgVv195RAlUWpQK00S5rRbPai',
  underMaintenance: false,
  shopifyPricingPlanUrl: 'https://admin.shopify.com/charges/droxy/pricing_plans',
  whatsAppEmbeddedSignupConfigId: '465548729656964',
  facebookEmbeddedSignupConfigId: '944778701001741',
  livekitProjectUrl: 'wss://droxy-1og4i4e1.livekit.cloud'
};

const dev: Config = {
  isDev: true,
  serverBaseUrl: 'http://localhost:3000',
  host: 'localhost:4200',
  chatScriptName: 'chat.js',
  stripePK:
    'pk_test_51MmP7xJ94jlMIjO87uySBprfbNp3qx3GSkhNlk6UMFEM9ueIxY2ml93NO7XUqRdTFLZRYUaDHDdJWty5cTetoyZI00PTMeswCT',
  underMaintenance: false,
  shopifyPricingPlanUrl: 'https://admin.shopify.com/charges/droxy-dev/pricing_plans',
  whatsAppEmbeddedSignupConfigId: '491128907189374',
  facebookEmbeddedSignupConfigId: '1066935068395277',
  livekitProjectUrl: 'wss://droxy-dev-1iml5cyo.livekit.cloud'
};

export const config: Config = process.env.NODE_ENV === 'development' ? dev : prod;
